









































































import { computed } from "@vue/composition-api";
import Vue from "vue";
export default Vue.extend({
  props: ["is_loading", "analysis"],
  setup(props) {
    const display_labels = computed(() => {
      // @ts-ignore
      const labels = props.analysis.associatedLabels.overlappingLabels;
      const high_confidence_labels = labels.filter(
        // @ts-ignore
        (label) => label.confidence >= 0.5
      );
      if (high_confidence_labels.length < 10) {
        return labels;
      } else {
        return high_confidence_labels;
      }
    });
    return {
      display_labels,
    };
  },
});
